module.exports = __webpack_public_path__ + "nav-white-7c3bb94f21f5dbf8c4e5.svg";